import React from 'react';

import {
    View,
    StyleSheet
} from 'react-native';
import {
    JDText,
    JDImage,
    JDTouchable
} from '@jdreact/jdreact-core-lib';

import { pt } from '../../common/utils';
import img from '../../common/img';

export default (props) => {
    const { isUsedYingDou, allYingDouCount, yingdouCount, toggleYinDouBtn, onlinePayFee, isYingDouError } = props;
    const cantUse = isUsedYingDou ? false : (onlinePayFee === 0 || yingdouCount === 0);

    return (
        !isYingDouError && allYingDouCount > 0 && <View style={ st.jdbeans }>
            {
                cantUse
                    ? <View style={ st.left }>
                        <JDText style={ st.txt }>共
                            <JDText type='regular'>{allYingDouCount}</JDText>
                            影豆
                        </JDText>
                        <View style={ st.v_txt }>
                            <JDText style={ st.is_use }>无可用</JDText>
                        </View>
                    </View>
                    : <JDText style={ st.txt }>
                        共
                        <JDText type='regular'>{allYingDouCount}</JDText>
                        影豆，{isUsedYingDou ? '已' : '可'}用{yingdouCount}影豆，抵
                        <JDText type='regular'>&yen;{yingdouCount / 100}</JDText>
                        元
                    </JDText>

            }

            {
                !cantUse &&
                    <JDTouchable onPress={ toggleYinDouBtn } >
                        <JDImage style={ st.btn } source={ isUsedYingDou ? img.on : img.off } />
                    </JDTouchable>
            }

        </View>
    );
};

const st = StyleSheet.create({
    jdbeans: {
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'row',
        backgroundColor: '#fff',
        padding: pt(10),
        paddingVertical: pt(5),
        height: pt(38)
    },
    txt: {
        fontSize: pt(12)
    },
    left: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    v_txt: {
        borderRadius: pt(4),
        paddingHorizontal: pt(5),
        paddingVertical: pt(2),
        backgroundColor: 'rgba(217, 217, 217, 1)',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: pt(3),
        height: pt(18)
    },
    is_use: {
        color: '#fff',
        fontSize: pt(12)
    },
    btn: {
        height: pt(24),
        width: pt(48)
    }
});
